import i18n from "../../../i18n";
import { utcToLocalTime } from "../../../Utils/formant";
import { Notification } from "../../../Utils/Notification";
import { SetStorage } from "../../../Utils/Storage";
import { toast } from "react-hot-toast";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import momentJ from "moment-jalaali";

export const Dialogs = (state, action) => {
  return {
    ...state,
    dialogsFlag: {
      ...state.dialogsFlag,
      [action.key]: action.value,
    },
  };
};

export const clearState = (state, action, initial) => {
  return {
    ...state,
    [action.state]: initial[action.state],
  };
};

export const SearchOrgs = (state, action) => {
  const updateValue = {
    request: state.Organizations.request,
    error: state.Organizations.error,
    response: action.data,
    allOrgs: state.Organizations.allOrgs,
  };
  return { ...state, Organizations: updateValue };
};

export const getOrganization = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: state.Organizations.response,
    allOrgs: state.Organizations.allOrgs,
  };
  return { ...state, Organizations: updateValue };
};
export const getOrganizationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: null,
    allOrgs: null,
  };
  if (action.getAll) {
    updateValue.response = state.Organizations.response;
    updateValue.allOrgs = action.res.data;
  } else {
    updateValue.response = action.res.data;
    updateValue.allOrgs = state.Organizations.allOrgs;
  }
  return { ...state, Organizations: updateValue };
};
export const getOrganizationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
    allOrgs: state.Organizations.allOrgs,
  };
  return { ...state, Organizations: updateValue };
};

export const addOrg = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddOrg: updateValue };
};
export const addOrgSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(i18n.t("Notification.AddOrg"), "success");
  return { ...state, AddOrg: updateValue };
};
export const addOrgFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddOrg: updateValue };
};

export const editOrg = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, EditOrg: updateValue };
};
export const editOrgSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );

  return { ...state, EditOrg: updateValue };
};
export const editOrgFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, EditOrg: updateValue };
};

export const editTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AditTenant: updateValue };
};
export const editTenantSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };

  Notification.pushNotif(i18n.t("Tenant update successfully"), "success");
  return { ...state, AditTenant: updateValue };
};
export const editTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AditTenant: updateValue };
};

export const clonePlan = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, clonePlan: updateValue };
};
export const clonePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    action.res.data?.messageFa || action.res.data?.message || "success",
    "success"
  );
  return { ...state, clonePlan: updateValue };
};
export const clonePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    action.error.response?.data?.messageFa ||
    action.error.response?.data?.message ||
    "Error",
    "error"
  );
  return { ...state, clonePlan: updateValue };
};

export const turnBackPlan = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, turnBackPlan: updateValue };
};
export const turnBackPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    action.res.data?.messageFa || action.res.data?.message || "success",
    "success"
  );
  return { ...state, turnBackPlan: updateValue };
};
export const turnBackPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    action.error.response?.data?.messageFa ||
      action.error.response?.data?.message ||
      "Error",
    "error"
  );
  return { ...state, turnBackPlan: updateValue };
};

export const createAppVersion = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, createVersion: updateValue };
};
export const createAppVersionSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    action.res.data?.messageFa || action.res.data?.message || "success",
    "success"
  );
  return { ...state, createVersion: updateValue };
};
export const createAppVersionFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    action.error.response?.data?.messageFa ||
    action.error.response?.data?.message ||
    "Error",
    "error"
  );
  return { ...state, createVersion: updateValue };
};

export const addTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddTenant: updateValue };
};
export const addTenantSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, AddTenant: updateValue };
};
export const addTenantFail = (state, action) => {
  Notification.pushNotif(i18n.dir() ==="rtl" ? action?.error?.response?.data?.messageFa : action?.error?.response?.data?.message,"error")

  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddTenant: updateValue };
};

export const getOrgById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.Organization.response,
    error: null,
    admins: state.Organization.admins,
  };
  return { ...state, Organization: updateValue };
};
export const getOrgByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    admins: action.res.data?.orgAdmin,
    error: null,
  };
  return { ...state, Organization: updateValue };
};
export const getOrgByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
    admins: state.Organization.admins,
  };
  return { ...state, Organization: updateValue };
};

export const getAllTenants = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.Tenants.response,
    error: null,
  };
  return { ...state, Tenants: updateValue };
};
export const getAllTenantsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, Tenants: updateValue };
};
export const getAllTenantsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Tenants: updateValue };
};

export const changeOrgActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgActivation: updateValue };
};
export const changeOrgActivationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, OrgActivation: updateValue };
};
export const changeOrgActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrgActivation: updateValue };
};

export const changeTenantActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantActivation: updateValue };
};
export const changeTenantActivationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, TenantActivation: updateValue };
};
export const changeTenantActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantActivation: updateValue };
};

export const deleteTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeleteTenant: updateValue };
};
export const deleteTenantSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, DeleteTenant: updateValue };
};
export const deleteTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DeleteTenant: updateValue };
};

export const downloadOptimizePlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadOptimizePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadOptimizePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadExcelPlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const downloadExcelPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const downloadExcelPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const getOrganizationUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrganizationUser: updateValue };
};
export const getOrganizationUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, OrganizationUser: updateValue };
};
export const getOrganizationUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrganizationUser: updateValue };
};

export const getWebhookConfig = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, WebhookConfig: updateValue };
};
export const getWebhookConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, WebhookConfig: updateValue };
};
export const getWebhookConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, WebhookConfig: updateValue };
};

export const setWebhookConfig = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, SetWebhookConfig: updateValue };
};
export const setWebhookConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, SetWebhookConfig: updateValue };
};
export const setWebhookConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, SetWebhookConfig: updateValue };
};

export const getVerificationConfig = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, VerificationConfig: updateValue };
};
export const getVerificationConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, VerificationConfig: updateValue };
};
export const getVerificationConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, VerificationConfig: updateValue };
};

export const setVerificationConfig = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, SetVerificationConfig: updateValue };
};
export const setVerificationConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, SetVerificationConfig: updateValue };
};
export const setVerificationConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, SetVerificationConfig: updateValue };
};

export const getTenantUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantUser: updateValue };
};
export const getTenantUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, TenantUser: updateValue };
};
export const getTenantUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantUser: updateValue };
};

export const getTenantById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, Tenant: updateValue };
};
export const getTenantByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, Tenant: updateValue };
};
export const getTenantByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Tenant: updateValue };
};

export const updateTenantUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdateTenantUser: updateValue };
};
export const updateTenantUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, UpdateTenantUser: updateValue };
};
export const updateTenantUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdateTenantUser: updateValue };
};

export const updateOrgUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdateOrgUser: updateValue };
};
export const updateOrgUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, UpdateOrgUser: updateValue };
};
export const updateOrgUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, UpdateOrgUser: updateValue };
};

export const addOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.AddOrgPOC.response,
    error: null,
  };
  return { ...state, AddOrgPOC: updateValue };
};
export const addOrgPOCSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, AddOrgPOC: updateValue };
};
export const addOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddOrgPOC: updateValue };
};

export const removeOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RemoveOrgPOC: updateValue };
};
export const removeOrgPOCSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: true,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, RemoveOrgPOC: updateValue };
};
export const removeOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, RemoveOrgPOC: updateValue };
};

export const getOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgPOC: updateValue };
};
export const getOrgPOCSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, OrgPOC: updateValue };
};
export const getOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrgPOC: updateValue };
};

export const updateOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdatePOC: updateValue };
};
export const updateOrgPOCSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, UpdatePOC: updateValue };
};
export const updateOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdatePOC: updateValue };
};

export const changeOrgPassword = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgPassword: updateValue };
};
export const changeOrgPasswordSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, OrgPassword: updateValue };
};
export const changeOrgPasswordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  const errMessage = action?.error?.response?.data?.NewPassword[0]
  Notification.pushNotif(
      errMessage,
      "error"
  );
  return { ...state, OrgPassword: updateValue };
};

export const changeTenantPassword = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantPassword: updateValue };
};
export const changeTenantPasswordSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, TenantPassword: updateValue };
};
export const changeTenantPasswordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantPassword: updateValue };
};

export const downloadUsage = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, DownloadUsage: updateValue };
};
export const downloadUsageSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, DownloadUsage: updateValue };
};
export const downloadUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, DownloadUsage: updateValue };
};

export const getUserToken = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OtherUserToken: updateValue };
};
export const getUserTokenSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.token,
    error: null,
  };
  SetStorage("check_user_tenant_token", action.res.data?.token, "local");
  return { ...state, OtherUserToken: updateValue };
};
export const getUserTokenFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OtherUserToken: updateValue };
};

export const getOrganizationUsage = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgUsage: updateValue };
};
export const getOrganizationUsageSuccess = (state, action) => {
  const chartData = [];
  action.res.data?.entity.forEach((item) => {
    const obj = {};
    item.usageDetailList = item.usageDetailList.sort((a, b) => {
      if (a.amount > b.amount) {
        return -1;
      }
      if (a.amount === b.amount) {
        return 0;
      }
      return 1;
    });
    obj.name = utcToLocalTime(
      item.creationTime,
      action.interval === "DAILY"
        ? "jYYYY/jM/jD"
        : action.interval === "MONTHLY"
          ? "jYYYY/jM"
          : "HH:mm:ss"
    );
    item?.usageDetailList?.forEach((tenant) => {
      obj[tenant.tenantName] = tenant.amount;
    });
    let total = 0;
    Object.keys(obj).forEach((key) => {
      if (key !== "name") {
        total = total + obj[key];
      }
    });
    obj.Total = total;

    chartData.push(obj);
  });

  const TenantNamesList = action.res.data?.entity[0].usageDetailList.map(
    (item) => item.tenantName
  );

  const updateValue = {
    request: null,
    response: chartData,
    error: null,
    tenantsList: TenantNamesList,
  };

  return { ...state, OrgUsage: updateValue };
};
export const getOrganizationUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, OrgUsage: updateValue };
};

export const getOrganizationsUsage = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgsUsage: updateValue };
};
export const getOrganizationsUsageSuccess = (state, action) => {
  const chartData = [];
  action.res.data?.entity.forEach((item) => {
    const obj = {};
    item.usageDetailList = item.usageDetailList.sort((a, b) => {
      if (a.amount > b.amount) {
        return -1;
      }
      if (a.amount === b.amount) {
        return 0;
      }
      return 1;
    });
    obj.name = utcToLocalTime(
      item.creationTime,
      action.interval === "DAILY"
        ? "jYYYY/jM/jD"
        : action.interval === "MONTHLY"
          ? "jYYYY/jM"
          : "HH:mm:ss"
    );
    item?.usageDetailList?.forEach((tenant) => {
      obj[tenant.organizationName] = tenant.amount;
    });
    chartData.push(obj);
  });

  const OrganizationNamesList = action.res.data?.entity[0].usageDetailList.map(
    (item) => item.organizationName
  );

  const updateValue = {
    request: null,
    response: chartData,
    error: null,
    orgsList: OrganizationNamesList,
  };

  return { ...state, OrgsUsage: updateValue };
};
export const getOrganizationsUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, OrgsUsage: updateValue };
};

export const getOrgAdmins = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgAdmins: updateValue };
};
export const getOrgAdminsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data || [],
    error: null,
  };
  return { ...state, OrgAdmins: updateValue };
};
export const getOrgAdminsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrgAdmins: updateValue };
};

export const addOrgAdmin = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddOrgAdmin: updateValue };
};
export const addOrgAdminSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, AddOrgAdmin: updateValue };
};
export const addOrgAdminFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "error"
  );
  return { ...state, AddOrgAdmin: updateValue };
};

export const getAllPlans = (state, action) => {
  const updateValue = {
    request: action.data,
  };
  return { ...state, AllPlans: { ...state.AllPlans, ...updateValue } };
};
export const getAllPlansSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, AllPlans: updateValue };
};
export const getAllPlansFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "error"
  );
  return { ...state, AllPlans: updateValue };
};

export const setCustomSms = (state, action) => {
  const updateValue = {
    request: action.data,
  };
  return { ...state, SetCustomSms: { ...state.SetCustomSms, ...updateValue } };
};
export const setCustomSmsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, SetCustomSms: updateValue };
};
export const setCustomSmsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "error"
  );
  return { ...state, SetCustomSms: updateValue };
};

export const getCustomSms = (state, action) => {
  const updateValue = {
    request: action.data,
  };
  return {
    ...state,
    CustomSmsList: { ...state.CustomSmsList, ...updateValue },
  };
};
export const getCustomSmsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, CustomSmsList: updateValue };
};
export const getCustomSmsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "error"
  );
  return { ...state, CustomSmsList: updateValue };
};

export const setPlanStatus = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, SetPlanStatus: updateValue };
};
export const setPlanStatusSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "success"
  );
  return { ...state, SetPlanStatus: updateValue };
};
export const setPlanStatusFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res.data?.messageFa
      : action.res.data?.message,
    "error"
  );
  return { ...state, SetPlanStatus: updateValue };
};

export const restorePlan = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RestorePlan: updateValue };
};
export const restorePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, RestorePlan: updateValue };
};
export const restorePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, RestorePlan: updateValue };
};

export const executeManuallyCVRP = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ManuallyCVRP: updateValue };
};
export const executeManuallyCVRPSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.data?.messageFa : action.res?.data?.message,
    "success"
  );
  return { ...state, ManuallyCVRP: updateValue };
};
export const executeManuallyCVRPFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, ManuallyCVRP: updateValue };
};

export const changeUserActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UserActivation: updateValue };
};
export const changeUserActivationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, UserActivation: updateValue };
};
export const changeUserActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, UserActivation: updateValue };
};

export const createTenantUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddTenantUser: updateValue };
};
export const createTenantUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, AddTenantUser: updateValue };
};
export const createTenantUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, AddTenantUser: updateValue };
};

export const createOrgUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddOrgUser: updateValue };
};
export const createOrgUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, AddOrgUser: updateValue };
};
export const createOrgUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, AddOrgUser: updateValue };
};

export const getRoleFlag = (state, action) => {
  const updateValue = {
    request: action.data || true,
    response: null,
    error: null,
  };
  return { ...state, RoleFlags: updateValue };
};
export const getRoleFlagSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data?.entity,
    error: null,
  };
  return { ...state, RoleFlags: updateValue };
};
export const getRoleFlagFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, RoleFlags: updateValue };
};

export const getOrgRoleFlag = (state, action) => {
  const updateValue = {
    request: action.data || true,
    response: null,
    error: null,
  };
  return { ...state, OrgRoleFlags: updateValue };
};
export const getOrgRoleFlagSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data?.entity,
    error: null,
  };
  return { ...state, OrgRoleFlags: updateValue };
};
export const getOrgRoleFlagFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, OrgRoleFlags: updateValue };
};

export const getAllTenantUsers = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.TenantUsers.response || [],
    error: null,
  };
  return { ...state, TenantUsers: updateValue };
};
export const getAllTenantUsersSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  return { ...state, TenantUsers: updateValue };
};
export const getAllTenantUsersFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, TenantUsers: updateValue };
};

export const getAllOrgUsers = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.OrgUsers.response || [],
    error: null,
  };
  return { ...state, OrgUsers: updateValue };
};
export const getAllOrgUsersSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  return { ...state, OrgUsers: updateValue };
};
export const getAllOrgUsersFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, OrgUsers: updateValue };
};

export const getMissionReason = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, missionReason: updateValue };
};
export const getMissionReasonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data?.entity,
    error: null,
  };
  return { ...state, missionReason: updateValue };
};
export const getMissionReasonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, missionReason: updateValue };
};

export const addMissionReason = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddMissionReason: updateValue };
};
export const addMissionReasonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, AddMissionReason: updateValue };
};
export const addMissionReasonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, AddMissionReason: updateValue };
};

export const deleteMissionReason = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeleteMissionReason: updateValue };
};
export const deleteMissionReasonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, DeleteMissionReason: updateValue };
};
export const deleteMissionReasonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, DeleteMissionReason: updateValue };
};

export const updateMissionReason = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdateMissionReason: updateValue };
};
export const updateMissionReasonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, UpdateMissionReason: updateValue };
};
export const updateMissionReasonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, UpdateMissionReason: updateValue };
};

export const changeUserPassword = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UserPassword: updateValue };
};
export const changeUserPasswordSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.data?.messageFa
      : action.res?.data?.message,
    "success"
  );
  return { ...state, UserPassword: updateValue };
};
export const changeUserPasswordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, UserPassword: updateValue };
};

export const getUserOfTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UserOfTenant: updateValue };
};
export const getUserOfTenantSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data?.entity,
    error: null,
  };
  return { ...state, UserOfTenant: updateValue };
};
export const getUserOfTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, UserOfTenant: updateValue };
};

export const getAllRoles = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, Roles: updateValue };
};
export const getAllRolesSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.data?.data,
    error: null,
  };
  return { ...state, Roles: updateValue };
};
export const getAllRolesFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, Roles: updateValue };
};

export const getRolesById = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, RoleById: updateValue };
};
export const getRolesByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data.data,
    error: null,
  };
  return { ...state, RoleById: updateValue };
};
export const getRolesByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, RoleById: updateValue };
};

export const getLogs = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, PlanLogs: updateValue };
};
export const getLogsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data.entity,
    error: null,
  };
  return { ...state, PlanLogs: updateValue };
};
export const getLogsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, PlanLogs: updateValue };
};

export const getRoleOrgs = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: null,
  };
  return { ...state, RoleOrgsList: updateValue };
};
export const getRoleOrgsSuccess = (state, action) => {
  const newList = action.res.data.data.map((el) => ({
    id: el.id,
    name: el.name,
  }));
  const updateValue = {
    request: null,
    error: null,
    response: newList,
  };
  return { ...state, RoleOrgsList: updateValue };
};
export const getRoleOrgsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, RoleOrgsList: updateValue };
};

export const getOrgsListId = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: null,
  };
  return { ...state, orgsIdList: updateValue };
};
export const getOrgsListIdSuccess = (state, action) => {
  const data = {};
  action.res.data.forEach((item) => (data[item.id] = item.name));
  const updateValue = {
    request: null,
    error: null,
    response: data,
  };
  return { ...state, orgsIdList: updateValue };
};
export const getOrgsListIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, orgsIdList: updateValue };
};

export const addRole = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: null,
    item: action.data,
  };
  return { ...state, AddRole: updateValue };
};
export const addRoleSuccess = (state, action) => {
  const updateValue = {
    ...state.AddRole,
    request: null,
    error: null,
    response: action.res,
  };
  toast.success(
    `New role “${state.AddRole.item?.role?.name}” Successfully Created.`,
    {
      duration: 3000,
    }
  );

  return { ...state, AddRole: updateValue };
};
export const addRoleFail = (state, action) => {
  const updateValue = {
    ...state.AddRole,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`New role “${state.AddRole.item?.role?.name}” Creation Failed.`, {
    duration: 3000,
  });
  return { ...state, AddRole: updateValue };
};

export const deleteRole = (state, action) => {
  const updateValue = {
    request: action.item,
    error: null,
    response: null,
    item: action.item,
  };
  return { ...state, DeleteRole: updateValue };
};
export const deleteRoleSuccess = (state, action) => {
  const updateValue = {
    ...state.DeleteRole,
    request: null,
    error: null,
    response: action.res,
  };
  toast.success(`“${state.DeleteRole.item?.name}” Successfully Deleted.`, {
    duration: 3000,
    icon: <DeleteOutlineIcon />,
  });
  return { ...state, DeleteRole: updateValue };
};
export const deleteRoleFail = (state, action) => {
  const updateValue = {
    ...state.DeleteRole,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`Fail to Delete “${state.DeleteRole.item?.name}”.`, {
    duration: 3000,
  });
  return { ...state, DeleteRole: updateValue };
};

export const editRole = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: null,
    item: action.data,
  };
  return { ...state, EditRole: updateValue };
};
export const editRoleSuccess = (state, action) => {
  const updateValue = {
    ...state.EditRole,
    request: null,
    error: null,
    response: action.res,
  };
  toast.success(
    `role “${state.EditRole.item?.role?.name}” Successfully Edited.`,
    {
      duration: 3000,
    }
  );
  return { ...state, EditRole: updateValue };
};
export const editRoleFail = (state, action) => {
  const updateValue = {
    ...state.EditRole,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`role “${state.EditRole.item?.role?.name}” Editing Failed.`, {
    duration: 3000,
  });
  return { ...state, EditRole: updateValue };
};

export const getMenu = (state, action) => {
  const updateValue = {
    request: action,
    error: null,
    response: null,
  };
  return { ...state, AllMenu: updateValue };
};
export const getMenuSuccess = (state, action) => {
  const updateValue = {
    response: action.res.data.data,
    error: null,
    request: null,
  };
  return { ...state, AllMenu: updateValue };
};
export const getMenuFail = (state, action) => {
  const updateValue = {
    request: null,
    error: action.error,
    response: null,
  };
  return { ...state, AllMenu: updateValue };
};

export const getAction = (state, action) => {
  const updateValue = {
    request: action,
    error: null,
    response: null,
  };
  return { ...state, AllAction: updateValue };
};
export const getActionSuccess = (state, action) => {
  const updateValue = {
    response: action.res.data.data,
    error: null,
    request: null,
  };
  return { ...state, AllAction: updateValue };
};
export const getActionFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AllAction: updateValue };
};

export const RoleModify = (state, action) => {
  const newData =
    action.action === "clear"
      ? {
        edit: null,
        delete: null,
      }
      : {
        ...state.roleModifyActions,
        [action.action]: action.data,
      };
  return {
    ...state,
    roleModifyActions: newData,
  };
};

export const getAllContracts = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, allContracts: updateValue };
};
export const getAllContractsSuccess = (state, action) => {
  const res = action.res.data?.entity?.items;
  const modifyRes = res.map((el) => {
    const isActive =
      new Date(el.endDate).getTime() - new Date().getTime() > 0
        ? "active"
        : "expired";
    const remaining = el.total - el.used;
    const mustRemind = () => {
      const isDeadlineTime =
        (new Date(el.endDate).getTime() - new Date().getTime()) /
        (60 * 60 * 24 * 1000) <
        60;
      const isUnder20 = remaining / el.total < 0.2;
      if ((isDeadlineTime || isUnder20) && isActive === "active") {
        return true;
      } else {
        return false;
      }
    };
    // console.log({ name: el.organizationName, danger: mustRemind() });
    const myCustomObj = {
      ...el,
      startFa: momentJ(el.startDate).format("jYYYY/jM/jD"),
      endFa: momentJ(el.endDate).format("jYYYY/jM/jD"),
      // isActive,
      // reminder: mustRemind(),
      // remaining,
      // carCount: 0,
      // userCount: 0,
      // overUsedCount: 0,
    };
    return myCustomObj;
  });
  const newRes = {
    totalCount: action.res.data?.entity?.totalCount,
    items: modifyRes,
  };
  const updateValue = {
    request: null,
    response: newRes,
    error: null,
  };
  return { ...state, allContracts: updateValue };
};
export const getAllContractsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, allContracts: updateValue };
};

export const addContract = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    item: action.data,
  };
  return { ...state, addContract: updateValue };
};
export const addContractSuccess = (state, action) => {
  const updateValue = {
    ...state.addContract,
    request: null,
    response: action.res,
    error: null,
  };
  toast.success(`New Contract Successfully Created.`, {
    duration: 3000,
  });
  return { ...state, addContract: updateValue };
};
export const addContractFail = (state, action) => {
  const updateValue = {
    ...state.addContract,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`New Contract Creation Failed.`, {
    duration: 3000,
  });
  return { ...state, addContract: updateValue };
};

export const deleteContract = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    item: action.item,
  };
  return { ...state, deleteContract: updateValue };
};
export const deleteContractSuccess = (state, action) => {
  const updateValue = {
    ...state.deleteContract,
    request: null,
    response: action.res,
    error: null,
  };
  toast.success(`Contract Successfully Deleted.`, {
    duration: 3000,
    icon: <DeleteOutlineIcon />,
  });
  return { ...state, deleteContract: updateValue };
};
export const deleteContractFail = (state, action) => {
  const updateValue = {
    ...state.deleteContract,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`Fail to Delete Contract.`, {
    duration: 3000,
  });
  return { ...state, deleteContract: updateValue };
};

export const removeReminder = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    item: action.data,
  };
  return { ...state, removeReminder: updateValue };
};
export const removeReminderSuccess = (state, action) => {
  const updateValue = {
    ...state.removeReminder,
    request: null,
    response: action.res,
    error: null,
  };
  toast.success(
    `Contract's reminder status successfully changed.`,
    {
      duration: 3000,
      icon: <DeleteOutlineIcon />,
    }
  );
  return { ...state, removeReminder: updateValue };
};
export const removeReminderFail = (state, action) => {
  const updateValue = {
    ...state.removeReminder,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`Fail to Change Reminder.`, {
    duration: 3000,
  });
  return { ...state, removeReminder: updateValue };
};

export const removeOrgAccessByContractEnd = (state, action) => {
  const updateValue = {
    request: action.organizationId,
    response: null,
    error: null,
  };
  return { ...state, removeOrgAccessByContractEnd: updateValue };
};
export const removeOrgAccessByContractEndSuccess = (state, action) => {
  const updateValue = {
    ...state.removeOrgAccessByContractEnd,
    request: null,
    response: action.res,
    error: null,
  };
  toast.success(`Organization access successfully removed.`, {
    duration: 3000,
    icon: <DeleteOutlineIcon />,
  });
  return { ...state, removeOrgAccessByContractEnd: updateValue };
};
export const removeOrgAccessByContractEndFail = (state, action) => {
  const updateValue = {
    ...state.removeOrgAccessByContractEnd,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`Fail to remove organization access.`, {
    duration: 3000,
  });
  return { ...state, removeOrgAccessByContractEnd: updateValue };
};

export const editContract = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    item: action.data,
  };
  return { ...state, editContract: updateValue };
};
export const editContractSuccess = (state, action) => {
  const updateValue = {
    ...state.editContract,
    request: null,
    response: action.res,
    error: null,
  };
  toast.success(
    `Contract's edited successfully.`,
    {
      duration: 3000,
      icon: <DeleteOutlineIcon />,
    }
  );
  return { ...state, editContract: updateValue };
};
export const editContractFail = (state, action) => {
  const updateValue = {
    ...state.editContract,
    request: null,
    response: null,
    error: action.error,
  };
  toast.error(`Fail to Edit Contract.`, {
    duration: 3000,
  });
  return { ...state, editContract: updateValue };
};

export const getAccountUsage = (state, action) => {
  const updateValue = {
    request: action,
    error: null,
    response: null,
  };
  return { ...state, accountUsage: updateValue };
};
export const getAccountUsageSuccess = (state, action) => {
  const updateValue = {
    response: action.res.data,
    error: null,
    request: null,
  };
  return { ...state, accountUsage: updateValue };
};
export const getAccountUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, accountUsage: updateValue };
};


export const getPlanFlowProcess = (state, action) => {
  const updateValue = {
    request: action,
    error: null,
    response: null,
  };
  return { ...state, planFlowProcess: updateValue };
};
export const getPlanFlowProcessSuccess = (state, action) => {
  const updateValue = {
    response: action.res.data,
    error: null,
    request: null,
  };
  return { ...state, planFlowProcess: updateValue };
};
export const getPlanFlowProcessFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, planFlowProcess: updateValue };
};



export const getRabbitMqHealth = (state, action) => {
  const updateValue = {
    request: action,
    error: null,
    response: null,
  };
  return { ...state, rabbitMqHealth: updateValue };
};
export const getRabbitMqHealthSuccess = (state, action) => {
  const updateValue = {
    response: action.res.data,
    error: null,
    request: null,
  };
  return { ...state, rabbitMqHealth: updateValue };
};
export const getRabbitMqHealthFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, rabbitMqHealth: updateValue };
};